'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('react');
require('../../components/StyledMarkup/index.js');
require('../../components/Spinner/index.js');
require('../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
require('../../components/LocationCard/index.js');
require('../../components/PudoCard/index.js');
require('../../components/ItemCard/index.js');
var index = require('../../components/SelectItem/index.js');
require('../../components/SelectList/index.js');
require('../../components/ErrorBanner/index.js');
require('../../components/Footer/index.js');
require('../../components/StickyFooter/index.js');
require('../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/index.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/ItemCardSkeleton.js');
require('../../components/Skeleton/LineItemSkeleton.js');
require('../../components/Skeleton/PudoCardSkeleton.js');
var style = require('../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const FlexWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1s2l1e2-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
const Root = styled__default["default"](FlexWrapper).withConfig({
  componentId: "sc-1s2l1e2-1"
})(["padding:1.5rem;"]);
const Main = styled__default["default"](FlexWrapper).withConfig({
  componentId: "sc-1s2l1e2-2"
})(["width:100%;"]);
const DisclaimerText = styled__default["default"](FlexWrapper).withConfig({
  componentId: "sc-1s2l1e2-3"
})(["padding-top:16px;padding-bottom:8px;text-align:center;"]);
const RefundOptionList = styled__default["default"](FlexWrapper).withConfig({
  componentId: "sc-1s2l1e2-4"
})(["width:100%;max-width:520px;gap:8px;"]);
const RefundOptionItem = styled__default["default"](index["default"]).withConfig({
  componentId: "sc-1s2l1e2-5"
})(["width:100%;display:grid;grid-template-areas:", ";grid-template-columns:", ";column-gap:32px;row-gap:4px;@media screen and (max-width:768px){", "}"], _ref => {
  let {
    showAmount
  } = _ref;
  return showAmount ? `
        'Icon Title Amount'
        'Icon Description Amount'` : `
        'Icon Title'
        'Icon Description'`;
}, _ref2 => {
  let {
    showAmount
  } = _ref2;
  return showAmount ? 'auto 1fr auto' : 'auto 1fr';
}, _ref3 => {
  let {
    showAmount
  } = _ref3;
  return showAmount ? `
        grid-template-areas:
          'Icon Title'
          'Icon Description'
          'Icon Amount'
        ` : '';
});
const IconGrid = styled__default["default"].div.withConfig({
  componentId: "sc-1s2l1e2-6"
})(["grid-area:Icon;"]);
const TitleGrid = styled__default["default"].div.withConfig({
  componentId: "sc-1s2l1e2-7"
})(["grid-area:Title;> h4 > *{display:inline;vertical-align:middle;}> h4 > *:first-child{margin-right:12px;}"]);
const DescriptionGrid = styled__default["default"].div.withConfig({
  componentId: "sc-1s2l1e2-8"
})(["grid-area:Description;"]);
const AmountGrid = styled__default["default"](FlexWrapper).withConfig({
  componentId: "sc-1s2l1e2-9"
})(["grid-area:Amount;font-weight:700;align-items:start;align-self:center;"]);
const Chip = styled__default["default"].span.withConfig({
  componentId: "sc-1s2l1e2-10"
})(_ref4 => {
  var _theme$buttonsPrimary;
  let {
    theme
  } = _ref4;
  return {
    ...theme.bodytextDefaultNone,
    ...theme.smalltextDefaultNone,
    padding: '2px 8px',
    margin: 0,
    borderRadius: style.getBorderRadius(theme.selecteditemNoneNone) ?? style.getBorderRadius(theme.buttonsPrimaryDefault, 4),
    backgroundColor: style.getBorderColor(theme.selecteditemNoneNone) ?? ((_theme$buttonsPrimary = theme.buttonsPrimaryDefault) === null || _theme$buttonsPrimary === void 0 ? void 0 : _theme$buttonsPrimary.backgroundColor) ?? '#000',
    color: '#FFF',
    whiteSpace: 'nowrap'
  };
});

exports.AmountGrid = AmountGrid;
exports.Chip = Chip;
exports.DescriptionGrid = DescriptionGrid;
exports.DisclaimerText = DisclaimerText;
exports.IconGrid = IconGrid;
exports.Main = Main;
exports.RefundOptionItem = RefundOptionItem;
exports.RefundOptionList = RefundOptionList;
exports.Root = Root;
exports.TitleGrid = TitleGrid;
